module.exports = __webpack_public_path__ + "img/warning.ccc73a19.svg";